import api from '@/api';
import {
  SpedAssessmentConult,
  SpedAssessmentReport,
} from './sped-assessment.types';

const path = (id: number) => `/sped/v1/sped/sped-document/${id}/assessment`;

export default {
  async start(spedDocumentId: number) {
    const result = (await api.post(
      `${path(spedDocumentId)}/start`,
      {},
    )) as unknown;
    return result as void;
  },

  async report(spedDocumentId: number) {
    const result = (await api.post(
      `${path(spedDocumentId)}/report`,
      {},
    )) as unknown;
    return result as SpedAssessmentReport;
  },

  async consult(spedDocumentId: number) {
    const result = (await api.post(
      `${path(spedDocumentId)}/consult`,
      {},
    )) as unknown;
    return result as SpedAssessmentConult;
  },

  async reopen(spedDocumentId: number) {
    const result = (await api.post(
      `${path(spedDocumentId)}/reopen`,
      {},
    )) as unknown;
    return result as void;
  },
};
